import CampaignInsights from "./campaignInsights";
import ProductInsights from "./productInsights";

export function registerDirectives(Vue) {
  Vue.directive("product-insights", ProductInsights);
  Vue.directive("campaign-insights", CampaignInsights);
}
